import request from 'superagent';

let pendingRequest = null;

export default function translateBriefAction(context, { translateTo, url }, done) {
    context.dispatch('BRIEF_TRANSLATION_START', {
        language: translateTo,
    });

    if (pendingRequest) {
        pendingRequest.abort();
    }

    pendingRequest = request
        .get(url + '?lang=' + translateTo)
        .timeout(10000)
        .send()
        .end(function(err, res) {
            if (err) {
                context.dispatch('BRIEF_TRANSLATION_ERROR', {});
            } else {
                context.dispatch('BRIEF_TRANSLATION_SUCCESS', {
                    outline: JSON.parse(res.text),
                });
            }

            done();
        });
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/brief-translate.jsx